<a [routerLink]="['/home']" class="logo logo-light trendi-logo --light">
  <span class="logo-lg">
    <img src="assets/images/logo.svg" alt="Logo Trendmulti light" />
  </span>
  <span class="logo-sm">
    <img src="assets/images/logo-sm.svg" alt="Logo Trendmulti light" />
  </span>
</a>

<a [routerLink]="['/home']" class="logo logo-dark trendi-logo --dark">
  <span class="logo-lg">
    <img src="assets/images/logo-dark.svg" alt="Logo Trendmulti dark" />
  </span>
  <span class="logo-sm">
    <img src="assets/images/logo-dark-sm.svg" alt="Logo Trendmulti dark" />
  </span>
</a>

<div class="button-sm-hover" data-bs-toggle="tooltip" data-bs-placement="right">
  <i class="ri-checkbox-blank-circle-line align-middle"></i>
</div>

<div class="button-close-fullsidebar" (click)="closeSidebar()">
  <i class="ri-close-fill align-middle"></i>
</div>

<div class="h-100" id="leftside-menu-container" data-simplebar>
  <ul class="side-nav">
    <li class="side-nav-item" [routerLinkActive]="'menuitem-active'" (click)="closeSidebar()">
      <a [routerLink]="['/home']" class="side-nav-link">
        <i class="ri-dashboard-line"></i>
        <span>Dashboard </span>
      </a>
    </li>
    <li class="side-nav-item" [routerLinkActive]="'menuitem-active'" (click)="closeSidebar()">
      <a [routerLink]="['/company']" class="side-nav-link">
        <i class="ri-building-4-line"></i>
        <span>Empresas </span>
      </a>
    </li>
    <li class="side-nav-item" [routerLinkActive]="'menuitem-active'" (click)="closeSidebar()">
      <a [routerLink]="['/info']" class="side-nav-link">
        <i class="ri-information-line"></i>
        <span>Comunicação </span>
      </a>
    </li>
    <li class="side-nav-item" [routerLinkActive]="'menuitem-active'" (click)="closeSidebar()">
      <a [routerLink]="['/webhook']" class="side-nav-link">
        <i class="ri-code-line"></i>
        <span>Webhooks </span>
      </a>
    </li>
    <li class="side-nav-item" [routerLinkActive]="'menuitem-active'" (click)="closeSidebar()">
      <a [routerLink]="['/webhook-audit']" class="side-nav-link">
        <i class="ri-shield-keyhole-line"></i>
        <span>Auditoria de Webhooks </span>
      </a>
    </li>
    <li class="side-nav-item" [routerLinkActive]="'menuitem-active'" (click)="closeSidebar()">
      <a [routerLink]="['/payment-logging']" class="side-nav-link">
        <i class="ri-code-line"></i>
        <span>Payment Logging </span>
      </a>
    </li>
    <li class="side-nav-item" [routerLinkActive]="'menuitem-active'" (click)="closeSidebar()">
      <a [routerLink]="['/apis-logging']" class="side-nav-link">
        <i class="ri-code-line"></i>
        <span>Apis Logging </span>
      </a>
    </li>
  </ul>

  <div class="clearfix"></div>
</div>